import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircle} from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';
import './NumberItem.scss';

export default function NumberList({children, ...props}) {
  return <ol className={classNames(`number-list fa-ul`, props.className)}>{children}</ol>;
}

export function NumberListItem(props) {
  return (
    <li className={classNames(`number-list-item`, props.className)}>
      <div className="number-list-item-heading d-flex align-items-center text-green">
        <div className="number-list-item-count-wrap fa-layers">
          <FontAwesomeIcon className="number-list-item-count-circle" icon={faCircle} />
          <div className="number-list-item-count-number fa-layers-text text-800">{props.number}</div>
        </div>
        <div className="number-list-item-title">{props.title}</div>
      </div>

      <div className="number-list-item-content">
        <p>{props.children}</p>
      </div>
    </li>
  );
}
